import React, {ButtonHTMLAttributes, FC} from 'react';
import classes from './HLTextButton.module.scss';

interface HLTextButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
}

const HLTextButton: FC<HLTextButtonProps> = ({
                                               children,
                                               ...props
                                             }) => {
  return (
      <button
          className={classes.textButton}
          type="button"
          {...props}
      >
        {children}
      </button>
  );
};

export default HLTextButton;